/**
 * DatoCMS ids of menu items used for navigation & structured data features.
 * Update when replacing header menu item content for this item.
 */
export const SUCCESS_STORIES_HEADER_ITEM_ID = {
	en: "cgasbDadTpOfmqMzBLtV9w",
	de: "YnFPiv3ORgWExM7UZIvZaQ",
};
export const BLOG_HEADER_ITEM_ID = {
	en: "W2zXOCYtTWiwnRG3jDaltQ",
	de: "F7Q2DOBMTB2GRAoN7HvzFw",
};
export const SERVICES_HEADER_ITEM_ID = {
	en: "PrtLpjNHRGiWLysYMvLRbQ",
	de: "b8lmstFFRXW03t4_eEUAsg",
};
export const WORKSHOPS_HEADER_ITEM_ID = {
	en: "O2Sl2INHTvK-xHgtROiZxw",
	de: "U3wSjpnDT56esn903CEnYg",
};
